module.exports = __webpack_public_path__ + "static/media/darkness.954cdaef.png";